
<div *ngIf="state === 'loading'"
  [class]="class"
  class="brasao-loading"
  aria-label="Carregando brasao do municipio">
</div>
<img *ngIf="state === 'fallback'"
  [class]="class"
  class="brasao-fallback"
  src="/assets/images/betha-logo-sm.svg"
  alt="Logo da Betha">
<img *ngIf="state === 'image'"
  [class]="class"
  class="brasao-image"
  [src]="brasao"
  alt="Brasão do município de {{ municipio.nome}}">
